export const UTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};

  urlParams.forEach((value, key) => {
    if (key.startsWith("utm_")) {
      utmParams[key] = value;
    }
  });

  if (Object.keys(utmParams).length > 0) {
    localStorage.setItem("utm_data", JSON.stringify(utmParams));
  }
};
